module.exports = __webpack_public_path__ + "components/MapControl/svg/Źródło mineralne.svg?93d2e48f";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Źródło mineralne.svg
// module id = 2160
// module chunks = 0